<template>
  <div class="index">
    <div class="nav centered columns">
      <router-link :to="{ name: item.name }" :key="item.name"
      class="nav-item is-tab" active-class="is-active"
      v-for="item in userMenu">{{item.title}}</router-link>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      userMenu: []
    }
  },
  name: 'InformationContainer',
  methods: {
    ...mapActions(['logout', 'publishData'])
  },
  computed: {
    ...mapState(['menu', 'user'])
  },
  created () {
    this.userMenu = this.menu.information.filter(i => i.roles.includes(this.user.role))
  }
}
</script>

<style scoped>
.nav {
  margin: 15px 0 0;
  text-align: left;
  background: #eee;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: center;
  height: auto;
}
.nav a {
  align-items: baseline;
  padding-top: 10px;
  padding-bottom: 10px;
}
a:hover {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// Index.vue?f1372456